
import React, { useContext } from "react";
import { FaShieldAlt, FaHardHat, FaUserMd, FaSearch } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './AuditGlobal.css';
import BannerImage from './audit_hero.png';

function ISO45K1() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-45001-audit');
    } else {
      navigate('/login', { state: { from: '/booking/iso-45001-audit' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Safety Audit</span>
          <h1 className="hero-title">ISO 45001 Audit</h1>
          <p className="hero-subtitle">
            The gold standard for OH&S auditing. Verifying that your workplace is safe,
            healthy, and compliant.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Audit <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Protecting Human Capital</h2>
              <p className="article-text">
                Industrial accidents destroy lives and reputations. The ISO 45001 Audit is a rigorous examination
                of your Occupational Health and Safety Management System (OHSMS). It ensures that your safety
                policies are not just on paper, but practiced on the shop floor.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">What We Audit</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Risk Assessment:</strong> Is the HIRA comprehensive and up-to-date?</li>
                  <li><strong>Legal Compliance:</strong> Are you adhering to the Factories Act and other rules?</li>
                  <li><strong>Participation:</strong> Are workers involved in safety decisions?</li>
                  <li><strong>Emergency Response:</strong> Are drills conducted and recorded?</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Outcome</h2>
              <p className="article-text">
                The audit identifies non-conformities (NCs) and opportunities for improvement (OFIs).
                Addressing these leads to a safer workplace, reduced insurance premiums, and higher morale.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Audit Checklist</h4>
              <ul className="key-list">
                <li><FaSearch className="check-icon" /> Hazard Identification</li>
                <li><FaHardHat className="check-icon" /> PPE Compliance</li>
                <li><FaUserMd className="check-icon" /> Health Surveillance</li>
                <li><FaShieldAlt className="check-icon" /> Management Review</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Start your journey to ISO 45001 certification.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO45K1;
